export const isSomeStepValid = (
    action: ActionDto,
    validators: { (step: ActionStep): boolean }[]
) => {
    return action.options?.steps.some((step) => validators.every((validator) => validator(step)))
}
